import { assertRequired, assertEmail } from '../validators';

export default () => ({
  destinations: [],
  currentDestination: '',

  closeDialog() {
    this.$refs.dialog.close();
  },

  success() {
    if (this.$event.detail.success) {
      this.closeDialog();
    }
  },

  addDestination() {
    this.validate();
    if (assertRequired(this.currentDestination) && assertEmail(this.currentDestination)) {
      const existingEmailIdx = this.destinations.findIndex(
        (p) => p.toLowerCase() === this.currentDestination.toLowerCase(),
      );
      if (existingEmailIdx >= 0) {
        this.destinations.splice(existingEmailIdx, 1);
      }
      this.destinations.unshift(this.currentDestination);
      this.currentDestination = '';
    }
  },

  validate() {
    this.currentDestination = this.currentDestination.trim();
    if (!assertRequired(this.currentDestination) || assertEmail(this.currentDestination)) {
      this.$refs.emailInput.classList.remove('outline', 'outline-red-500', 'outline-2');
    } else {
      this.$refs.emailInput.classList.add('outline', 'outline-red-500', 'outline-2');
    }
  },

  cancelIfNoDestinations(event) {
    this.addDestination();
    if (this.destinations.length === 0) {
      this.$refs.emailInput.classList.add('outline', 'outline-red-500', 'outline-2');
      event.preventDefault();
    }
  },
});
